module.exports = __webpack_public_path__ + "img/ico001.fbede309.svg";